import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'
import { Props_SnippetLatestJobs } from './LatestJobs.props'

const SnippetLatestJobs = (props: Props_SnippetLatestJobs) => {
    const {
        snippet,
        heading,
        paragraph,
        link,
    } = props

    const theme = snippet.theme?.value;
    const showFrame = snippet.showFrame?.value;
    const contenPosition = snippet.contentPosition?.value;
    const backgroundImageSrc = snippet.backgroundImage?.value;
    const headingContent = heading.content?.value;
    const paragraphText = paragraph.text?.value;
    const showLink = link.linkText?.value && link.linkHref?.value;

    const buttonColorMap = {
        'hunter': 'primary',
        'dusty-rose': 'secondary',
        'terracotta': 'tertiary'
    };
    const linkStyle = buttonColorMap[theme as keyof typeof buttonColorMap];
    const frameClasses = showFrame ? '' : 'snippet-latest-jobs--frame-hidden';
    const contentClasses = `snippet-latest-jobs--content-${contenPosition}`;
    const sectionClasses = `snippet-latest-jobs snippet-latest-jobs--theme--${theme} ${frameClasses} ${contentClasses}`;

    return (
        <section
            className={sectionClasses}
        >
            <div className="snippet-latest-jobs__media">
                {backgroundImageSrc && (
                    <img
                        className="snippet-latest-jobs__image"
                        src={backgroundImageSrc}
                        alt=""
                        loading="lazy"
                    />
                )}
                <div className="snippet-latest-jobs__frame-mobile" aria-hidden="true" />
            </div>
            <div className="snippet-latest-jobs__inner">
                <div className="snippet-latest-jobs__text">
                    {headingContent && (
                        <div className="snippet-latest-jobs__heading">
                            {CompileMarkdown(headingContent)}
                        </div>
                    )}
                    {paragraphText && (
                        <div className="snippet-latest-jobs__paragraph">
                            {CompileMarkdown(paragraphText)}
                        </div>
                    )}
                    {showLink && (
                        <SnippetLink
                            linkStyles={linkStyle}
                            className="snippet-latest-jobs__link"
                            url={link.linkHref.value}
                            openInNewTab={link.linkTarget.value}
                        >
                            {link.linkText.value}
                        </SnippetLink>
                    )}
                </div>
                <div className="snippet-latest-jobs__frame-desktop" aria-hidden="true" />
            </div>
        </section>
    )
}

export default SnippetLatestJobs
